const showHeaderMenu = (headerMenu, overlay) => {
    toggleHeaderMenu(headerMenu, overlay, true);
};
const hideHeaderMenu = (headerMenu, overlay) => {
    toggleHeaderMenu(headerMenu, overlay, false);
};
const toggleHeaderMenu = (headerMenu, overlay, state) => {
    headerMenu.classList.toggle('--open', state);
    if (overlay) {
        overlay.classList.toggle('--open', state);
    }
};
export const initHeaderMenu = () => {
    const headerMenu = document.querySelector('.header-menu');
    if (!headerMenu) {
        return;
    }
    const overlay = document.querySelector('.header-menu__overlay');
    const menuElements = headerMenu.querySelectorAll('.header-menu__element');
    menuElements.forEach((menuElement) => {
        if (!menuElement.classList.contains('--with-sub-items')) {
            return;
        }
        menuElement.addEventListener('mouseenter', () => {
            if (window.innerWidth < 768) {
                return;
            }
            menuElement.classList.toggle('--open', true);
        });
        menuElement.addEventListener('mouseleave', () => {
            if (window.innerWidth < 768) {
                return;
            }
            menuElement.classList.toggle('--open', false);
        });
        menuElement.querySelector('.header-menu__top-element').addEventListener('click', () => {
            menuElement.classList.toggle('--open');
        });
    });
    const headerMenuToggle = document.querySelector('.header-menu__toggle');
    if (headerMenuToggle) {
        headerMenuToggle.addEventListener('click', () => showHeaderMenu(headerMenu, overlay));
        document
            .querySelector('main')
            .addEventListener('click', () => hideHeaderMenu(headerMenu, overlay));
        document
            .querySelector('footer')
            .addEventListener('click', () => hideHeaderMenu(headerMenu, overlay));
        document
            .querySelector('.header-menu__close-icon')
            .addEventListener('click', () => hideHeaderMenu(headerMenu, overlay));
        if (overlay) {
            overlay.addEventListener('click', () => hideHeaderMenu(headerMenu, overlay));
        }
    }
};
